
function init(){
  var column = 0;
 var source = document.querySelector("[data-whychoose-source]")
  if(source){
    Array.from(source.children).forEach(function(node){
      if(node.nodeName == 'H2' || node.nodeName == 'H3'){
        column ++
      }
      addToColumn(node, column)
    })
  }
}



function addToColumn (content, column){
  var div = document.querySelector("[data-whychoose-"+column+"]")
  div.append(content)
  highlightLinks(div);
}

function highlightLinks(div){
  var links = div.querySelectorAll('a');
  Array.from(links).forEach(function(link){
    link.classList.add('highlight')
  })
}

document.addEventListener("DOMContentLoaded", init)